import _ from "lodash";
import Fab from "@material-ui/core/Fab";
import IconVideoCam from "material-ui/svg-icons/av/videocam";
import IconImage from "material-ui/svg-icons/image/image";
import IconClear from "material-ui/svg-icons/navigation/cancel";
import React, { Component } from "react";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actionCreators from "../actions/customapps";
import ActionButton from "../components/common/ActionButton";
import ImagePicker from "../components/common/ImagePicker";
import NormalTextField from "../components/common/NormalTextField";
import Title from "../components/common/Title";
import VideoPicker from "../components/common/VideoPicker";
import FilePicker from "../components/common/FilePicker";
import "../resources/styles/BigCalendar.css";
import layout from "../styles/layout";
import AppFrame from "./AppFrame";

const style = {
  mediaButtonsRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignContent: "center",
    margin: 20,
  },
  media: {
    height: 100,
  },
  videoStyle: {
    flex: 1,
    width: "100%",
    maxHeight: 350,
    minWidth: 300,
  },
};

class AddGoalProgress extends Component {
  constructor(props) {
    super(props);

    this.state = {
      width: 0,
      height: 0,
      goalId: props.match.params.goalId,
      userId: this.props.user.userId,
      isPatient: this.props.user.isPatient,
      description: "",
      imageUrl: "",
      videoUrl: "",
      imageAdded: false,
      videoAdded: false,
    };
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener(
      "resize",
      this.updateWindowDimensions.bind(this)
    );
  }

  componentWillReceiveProps(nextProps) {
    if (!_.isEmpty(nextProps.user) && nextProps.user.userId) {
      this.setState({
        isPatient: nextProps.user.isPatient,
        userId: nextProps.user.userId,
      });
    }
  }

  savePrgressNote() {
    let attachmentList = [];

    if (this.state.videoUrl) {
      attachmentList.push({ url: this.state.videoUrl, type: "Video" });
    }

    if (this.state.imageUrl) {
      attachmentList.push({ url: this.state.imageUrl, type: "Image" });
    }

    this.props
      .addCustomAppGoalProgress(
        this.state.goalId,
        this.state.description,
        attachmentList,
        !this.state.isPatient
      )
      .then(() => {
        this.props.history.goBack();
      });
  }

  render() {
    let targetDevice = "desktop";
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      targetDevice = "mobile";
    }
    return (
      <AppFrame
        auth={this.props.auth}
        targetDevice={targetDevice}
        whiteLabelSettings={this.props.whiteLabelSettings}
      >
        <div style={layout.common.page}>
          <Title
            text2={"Patient Goal Progress"}
            goBack={() => this.props.history.goBack()}
            whiteLabelSettings={this.props.whiteLabelSettings}
          />

          <div style={layout.common.mainContainer}>
            <p>Add a photo or video</p>
            <div style={style.mediaButtonsRow}>
              <VideoPicker
                hidden={this.state.videoAdded}
                videoUrl={this.state.videoUrl}
                userId={this.props.user.userId}
                appId={-53}
                previewStyle={style.media}
                clearVideo={() => {
                  this.setState({
                    videoUrl: null,
                  });
                }}
                handleSubmit={(videoUrl) =>
                  this.setState({
                    videoUrl: videoUrl,
                  })
                }
              />
            </div>
            <div style={style.mediaButtonsRow}>
              <ImagePicker
                key={this.state.imageUrl}
                imageUrl={this.state.imageUrl}
                userId={this.props.user.userId}
                previewStyle={style.media}
                hidden={this.state.imageAdded}
                clearImage={() => {
                  this.setState({
                    imageUrl: null,
                  });
                }}
                handleSubmit={(imageUrl) =>
                  this.setState({
                    imageUrl: imageUrl,
                  })
                }
              />
            </div>
            <NormalTextField
              floatingLabelText="Write Note"
              fullWidth={true}
              multiLine={true}
              rows={5}
              rowsMax={10}
              value={this.state.description}
              onChange={(event) => {
                this.setState({ description: event.target.value });
              }}
            />
            <div style={{ display: "flex", flexDirection: "row-reverse" }}>
              <ActionButton
                label="Save Progress Note"
                onClick={() => this.savePrgressNote()}
                whiteLabelSettings={this.props.whiteLabelSettings}
              />
            </div>
          </div>
        </div>
      </AppFrame>
    );
  }
}

function mapStateToProps({
  user,
  apps,
  appusers,
  customapps,
  whiteLabelSettings,
}) {
  return {
    user,
    apps,
    appusers,
    customapps,
    whiteLabelSettings,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AddGoalProgress);



// WEBPACK FOOTER //
// ./src/layout/AddGoalProgress.js